import { IconButton, InputAdornment, TextField } from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";

function SearchFilter({ handlerSearchField, mainData, filteredData, text }) {
  return (
    <TextField
      variant="standard"
      label={text}
      onChange={handlerSearchField}
      disabled={mainData === true && filteredData.length === 0 ? true : false}
      sx={{
        width: {
          xs: "100%",
          md: "calc(100% / 2.5)",
          lg: "calc(100% / 3)",
        },
        marginBottom: { xs: 3, md: 0, lg: 0 },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

export default SearchFilter;
